import ko from 'knockout';

/**
 * Provides the bound DOM element in a component.
 */
ko.bindingHandlers.element = {
    /**
     * Initializes the binding, providing the bound DOM element to subscribers.
     * 
     * @param {HTMLElement} element The bound DOM element.
     * @param {() => (element: HTMLElement) => void} valueAccessor Provides the bound DOM element.
     */
    init(element, valueAccessor) {
        valueAccessor()(element);
    }
};